// Editable package pricing — update prices/inclusions here only.
const pricing = [
  {
    tier: "Essential",
    price: "₹1,20,000",
    image: "/images/pricing/essential.webp",
    description:
      "A considered starting point for couples who want thoughtful design without the full-scale build.",
    includes: [
      "Ceremony décor & seating",
      "Simple mandap styling",
      "Floral centerpieces",
      "Ambient lighting",
      "Day-of coordination",
    ],
  },
  {
    tier: "Premium",
    price: "₹1,85,000",
    image: "/images/pricing/premium.webp",
    description:
      "Our most-booked package — full décor across ceremony and reception, with dedicated on-site styling.",
    includes: [
      "Complete ceremony & reception décor",
      "Custom mandap design",
      "Floral installations",
      "Stage & backdrop design",
      "Ambient & accent lighting",
      "Full event coordination",
    ],
    featured: true,
  },
  {
    tier: "Signature",
    price: "₹2,50,000",
    image: "/images/pricing/signature.webp",
    description:
      "The complete Golden Wedding experience — every surface, every detail, designed as one story.",
    includes: [
      "Complete venue styling",
      "Mandap décor",
      "Floral installations",
      "Stage design",
      "Ambient lighting",
      "Entrance styling",
      "Event coordination",
    ],
  },
];

export default pricing;
